// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"c116d457","237":"203108b4","368":"d4dab387","411":"f5af4e67","480":"f44ca211","801":"11398270","866":"0ab9e109"}[chunkId] + ".chunk.js";
};